import React from "react";
import { GlobalContext } from '../../Context/GlobalContext';
import { Redirect } from 'react-router-dom';
import axios from "axios";

import Document from "../Document";
import Agenda from "../Agenda";
import Checkout from "../Modals/Stripe/Checkout";
import SelectOption from "../NewFuncComponents/Modals/SelectOption";
import ShareButton from '../Buttons/ShareButton';

import Video from "../Video";

import { parse, parseNumbers, parseText, parseSchedule } from "../../Helpers/parse";
import {getQueryVariable} from "Helpers/QueryString";
import copy from "copy-to-clipboard";
import * as crypto from "crypto-js";


const VIDEO_UPDATE_URL = "https://rkpf1ewcje.execute-api.us-west-2.amazonaws.com/";

const VIDEO_LOOKUP_URL = "https://3bljoanbf4.execute-api.us-west-2.amazonaws.com/";

const VIEWS_URL = "https://m513nl9tlc.execute-api.us-west-2.amazonaws.com/";

const DOCS_URL = 'https://y36ghvjzf4.execute-api.us-east-1.amazonaws.com/api';

class VideoScreen extends React.Component {
  static contextType = GlobalContext;
  state = {
    documents: [],
    file: {
      metadata: {},
      agenda: [],
      comments: [],
      views: [],
      shared: false,
      watchTime: 0,
      file: { metadata: { duration: 30 } },
      documentDisplay: false,
      videoStyle: { maxWidth: '100%' },
    },
    checkout: false,
    _watchToken: crypto.lib.WordArray.random(256).words.join(""),
    liveURL: "https://ak0i1ibny3.execute-api.us-west-2.amazonaws.com/default",
    playNext: false,
    shouldUpdate: false,
    scrubTo: 0,
    currentTime: 0,
    watchToken: null,
    schedule: [],
    schedule_info: {},
    schedule_metadata: {},
    lastViewUpdate: 0,
    liveViewCount: 0,
    itemBeingBought: '',
    hideVideoViews : false,
    redirect: false,
    hasDocsAndAgendas: false,
    popup:false,
    docsAgendasDisplay: ''
  };
  mounted = true;
  updateLiveViewsTimeout = null;

  componentDidMount() {
    window.scrollTo(0, 0);
    const validChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+{}:";
    
    let array = new Uint8Array(256);
    window.crypto.getRandomValues(array);
    array = array.map((x) => validChars.charCodeAt(x % validChars.length));
    const randomState = String.fromCharCode.apply(null, array);

    this.setState({
      id: this.props.video,
      _id: this.props.pub_user ? this.props.pub_user._id : "",
      watchToken: randomState,
    });
      
      axios.post(`${this.props.url}/upload/info`, { file: this.props.video } )
      .then(res => {
        let file = res.data.response.payload.file;

        if (
          this.props.pub_user &&
          file.downloadBuys &&
          file.downloadBuys.includes(this.props.pub_user._id)
        ) {
          file.downloadPrice = 0;
        }
        if (this.mounted) {
          const temp_hideVideoViews = res.data.response.payload?.file?.switches?.hideViews?.selected
          this.setState({
            file,
            shared: false,
            hideVideoViews : temp_hideVideoViews && temp_hideVideoViews == 'enabled' ? true : false
          });
        }

        axios.post(`${DOCS_URL}/file-documents`,
          { user: this.props.user, file: file._id }
        )
        .then(res => {
          if(res.status === 200) {
       
            this.setState(state => ({...state, documents: res.data }));

            // If documents and agendas exist, we put in a tab system to swap
            // between indexes and documents.
            if (this.state.documents.length > 0 && this.state.file.agenda.length > 0) {
              this.setState({
                ...this.state,
                videoStyle: { maxWidth: '100%' },
                hasDocsAndAgendas: true,
                docsAgendasDisplay: 'agenda'
              });
            } 
            else if (this.state.documents.length > 0 && this.state.file.agenda.length < 1) {
              this.setState({
                ...this.state,
                videoStyle: { maxWidth: '50%' },
                hasDocsAndAgendas: false,
                docsAgendasDisplay: 'document'
              });
            }
       
          }
        });      
      });
    
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  setPopup = val => {
    this.setState({popup:val})
  }

  setViews = (force=false, viewData={}, type) => {
    if(!type) {
      type = getQueryVariable("type");
    }

    let now = Date.now();

    if (this.state.watchToken && (now - this.state.lastViewUpdate > 30000 || force)) {
      if (type === "live") {
        axios.post(`${VIEWS_URL}live/view`, {
          file: this.props.video,
          view: {
            user: this.state.watchToken,
            ...viewData
          }
        })
      } else if (this.state.file && this.state.file._id && this.state.watchTime > 0) {
        
        axios.post(`${VIEWS_URL}video/view`, {
          file: { _id: this.state.file._id },
          view: {
            watchTime: this.state.watchTime,
            user:
              this.props.pub_user && this.props.pub_user._id
                ? this.props.pub_user._id
                : this.state.watchToken,
            ...viewData
          }
        })
      } else {
        // Do not set last view update if we did not actually update the view
        return
      }
      // This needs to be inside this block, or else views won't properly update
      if (this.mounted) {
        this.setState((state) => ({...state, lastViewUpdate: now}))
      }
    }
  }

  componentDidUpdate() {
    const file = this.state.file;
    
    const { companyEndpoint, viewerObj } = this.context;

    //check if the file metadata has loaded and if the file is apart of a subscription
    const monetizedFile = file.metadata?.associatedSubscriptions;
    if (monetizedFile) {
      // check if the file has any active subscriptions associated with it
      if (Object.keys(monetizedFile).length === 0) return;
      const product_Id = viewerObj?.subscription?.product_Id;
      //verify that the viewer has the correct subscription to view the video
      const activeSub = file.metadata.associatedSubscriptions.hasOwnProperty(product_Id);
      // redirect the viewer if they do not have the correct subscription
      if(!activeSub) {
        return this.setState({ ...this.state, redirect: true })
        // return window.location = `${window.location.origin}/vod/${companyEndpoint}`;
      }
    }

    if (this.props.pub_user && this.state._id !== this.props.pub_user._id) {

      let file = this.state.file;
 
      if (file.downloadBuys && file.downloadBuys.includes(this.props.pub_user._id)) {
        file.downloadPrice = 0;
        this.setState({ file });
      }
      this.setState({ _id: this.props.pub_user._id });
    }

    if (this.state.id !== this.props.video) {


      this.setState({ id: this.props.video });
      
      axios.post(`${this.props.url}/upload/info`, { file: this.props.video })
      .then(res => {
    
        if (this.mounted) {
          this.setState({
            file: res.data.response.payload.file,
            shared: false
          });
        }
      });
    }
  }

  getUrlAndCopy = () => {
    // Query the URL to determine type is live or not
    if (getQueryVariable("type") !== "live") {
      copy(`${this.props.url}/ssr/watch/${this.props.video}`);
    } else {
      copy(`${this.props.url}/ssr/live/${this.props.video}`);
    }
    this.setState({ copied: true });
  }

  // downloadVideo = () => {
    
  //   axios.post(`${this.props.url}/upload/get`, {
  //     file: this.props.video,
  //     user: this.props.pub_user ? this.props.pub_user._id : null,
  //   })
  //   .then(res => {
  //     if (res.data.response.success) {
  //       axios({
  //         url: res.data.response.payload.data, //your url
  //         method: "GET",
  //         responseType: "blob", // important
  //         onDownloadProgress: (progressEvent) => {
  //           const totalLength = progressEvent.lengthComputable
  //             ? progressEvent.total
  //             : progressEvent.target.getResponseHeader("content-length") ||
  //               progressEvent.target.getResponseHeader("x-decompressed-content-length");
       
  //           if (this.mounted && totalLength !== null) {
  //             this.setState({
  //               downloadPercentage: (progressEvent.loaded * 100) / totalLength,
  //             });
  //           }
  //         }
  //       })
  //       .then(response => {
  //         const url = window.URL.createObjectURL(new Blob([response.data]));
  //         const link = document.createElement("a");
  //         link.href = url;
  //         //or any other extension
  //         link.setAttribute("download", `${this.state.file.metadata.filename}.mp4`); 
  //         document.body.appendChild(link);
  //         link.click();
  //       });

  //     }
  //   });
  // }

  //opens modal for the download being bought
  handleCheckoutClick = () => {
    // if (this.props.pub_user._id === "") {
    //   this.props.register();
    // } else this.setState({ checkout: true, itemBeingBought: 'download'});
  }

  // opens modal for the video being bought
  setItemBeingBought = () => {
    // if (this.props.pub_user._id === "") {
    //   this.props.register();
    // } else this.setState({ checkout: true, itemBeingBought: 'payToView'});
  }

  // change tab display between indexes and documents
  changeTabDisplay = (name) => {
    if (name === 'agenda') {
      this.setState({ 
        ...this.state, 
        videoStyle: { maxWidth: '100%' },
        docsAgendasDisplay: 'agenda'
      });
    } else if (name === 'document') {
      this.setState({
        ...this.state,
        videoStyle: { maxWidth: '50%' },
        docsAgendasDisplay: 'document'
      });
    }
  };

  render() {
    const { ownerOfVODId, companyEndpoint, viewerId, config, darkMode } = this.context;
    if (this.state.redirect) {
      return <Redirect 
              to={{
                pathname: `/${companyEndpoint}/subscriptions`,
                state: { associatedSubscriptions: this.state.file.metadata.associatedSubscriptions }
              }}/>
    }

    // Props going to reusable ShareButton component
    let shareVideoButtonProps = {
      color: this.props.color,
      copied: this.state.copied,
      downloadsDisabled: this.props.downloadsDisabled,
      downloadPercentage: this.state.downloadPercentage,
      file: this.state.file,
      checkout: this.state.checkout,
      embedCopy: this.state.embedCopy,
      buttonText: "SHARE",
      onCopyUrlClick: this.getUrlAndCopy,
      onDownloadVideoClick: this.downloadVideo,
      onCheckoutClick: this.handleCheckoutClick,
      onEmbedVideoClick: this.embedVideo,
      copyUrlToolTip: "Copy Video URL",
      downloadVideoToolTip: "Download Video",
      payForVideoToolTip: "Pay to Download Video",
      embedToolTip: "Embed Video",
      embedToolTipPlacement: "top",
    }
    
    const attachedDocs = this.state.docsAgendasDisplay || this.state.documents.length

    return (
      <div className={`mt-3 ${attachedDocs ? "custom-container-plus" : " "}` } id="body">

        <div className={attachedDocs ? "row" : ""}>
          <div 
            className={attachedDocs ? "col-lg-9" : ""} 
            style={attachedDocs ? this.state.videoStyle : { margin: "auto", maxWidth: "75%" }}
          >
            <div className="video-player-wrapper">
              <div className="video-player" >
                <Video
                  translations={this.state.file.translations}
                  register={this.props.register}
                  viewerId={viewerId}
                  color={this.props.color}
                  file={this.state.file}
                  url={this.props.url}
                  user={this.props.user}
                  pub_user={this.props.pub_user}
                  setItemBeingBought={this.setItemBeingBought}
                  video={this.props.video}
                  setViews={this.setViews}
                  videoProps={{
                    onTimeUpdate: () => this.setViews(),
                    onPause: () => this.setViews(true),
                    onPlay: () => this.setViews(true)
                  }}

                  update={(time) => {
                    if (this.state.currentTime !== time) {
                      this.setState({ currentTime: time });
                      if (Math.abs(time - this.state.file.metadata.duration) < 1.5) {
                        this.setState({ watchTime: time });
                        setTimeout(() => {
                          this.setState({ playNext: true });
                        }, 5000);
                      } else {
                        this.setState({ watchTime: time, playNext: true });
                      }
                    }
                  }}
                  type={getQueryVariable("type") ? getQueryVariable("type") : "video"}
                  shouldUpdate={this.state.shouldUpdate}
                  clearUpdate={() => this.setState({ shouldUpdate: false })}
                  scrubTo={this.state.scrubTo}
                  shouldPlay={this.state.file.watchPrice > 0 ? false : true}
                />
              </div>
            </div>
            
            <div className="border-bottom flex-row" style={{ justifyContent: "space-between" }}>
              <div className="mb-3 flex-1">

                <span className="dt" style={{ whiteSpace: "pre-wrap", color: darkMode ? "#fff" : "#000" }}>
                  unlisted <i class="fa-regular fa-eye-slash"></i>
                </span>

                <h1 className="display-4 sm">
                  {this.state.file.metadata ? 
                    this.state.file.metadata.filename
                      : 
                    (this.state.file.name !== "MongoNetworkError" ? this.state.file.name : null)
                  }
                </h1>

                {/* <h1 className={darkMode ? "dark dt" : "dt"}>
                  {!config.hideViews && !this.state.hideVideoViews && this.state.file.views ? (getQueryVariable("type") === "live"
                    ? this.parseLive(this.state.file.views)
                    : this.state.file.views.length === 1
                    ? `${parseNumbers(this.state.file.views.length)} view .`
                    : `${parseNumbers(this.state.file.views.length)} views .`) : null
                  }

                  {this.state.file.watchPrice > 0
                    ? `  Watch Price:· $${this.state.file.watchPrice.toFixed(2)}`
                    : null
                  }
                  {this.state.file.downloadPrice > 0
                    ? ` Download Price· $${this.state.file.downloadPrice.toFixed(2)}`
                    : null
                  } 
                </h1> */}
                <h1 className={darkMode ? "dark dt" : "dt"} style={{ whiteSpace: "pre-wrap" }}>
                  {this.state.file.metadata?.description ? 
                    `Description: ${this.state.file.metadata.description}`
                      : 
                    null 
                  }
                </h1>
              </div>

            </div>

          </div>

        <div className="col-lg-3">
          {this.state.checkout && <Checkout
              url={this.props.url}
              user={this.props.user}
              visible={this.state.checkout}
              pub_user={this.props.pub_user}
              item={this.state.file}
              viewerId={viewerId}
              companyEndpoint={companyEndpoint}
              ownerOfVODId={ownerOfVODId}
              itemBeingBought={this.state.itemBeingBought}
              close={() => {this.setState({ checkout: false })}}/>
          }

          {/* Display document if it exists */}
          {this.state.documents.length > 0 ? 
            <Document
              documents = {this.state.documents ? this.state.documents: []} 
              width = {'200%'}
              tabDisplay={this.state.docsAgendasDisplay}
              hasAgenda={this.state.hasDocsAndAgendas}
              changeDisplay={this.changeTabDisplay}
            /> : null
          }

          {this.state.docsAgendasDisplay === 'agenda' ?
            <Agenda 
              video={this.props.video}
              items={this.state.file.agenda ? this.state.file.agenda : []}
              scrubTo={ (time) => this.setState({ shouldUpdate: true, scrubTo: time }) } 
              curentTime={this.state.currentTime}
              color={this.props.color}
              file={this.state.file._id}
              url={this.props.url}
            /> : null
          }

        </div>
        </div>
        {this.state.popup ? ( 
            <SelectOption 
            file={this.state.file} 
            translations={this.state.file.translations} 
            setPopup={this.setPopup}/> 
          ) : null 
        }
      </div>
    );
  }
}

export default VideoScreen;
